import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { useElementIDAndRefSync } from "../ElementSync/index.js";
import styles from "./styles.css";

/**
 * Renders container where the currently focused option is rendered. Requires option to render contents
 * in `OnFocusContainer` component
 **/
const FocusedOption = _ref => {
  let {
    as: ComponentToRender,
    className,
    id: idProp,
    ...props
  } = _ref;
  const [id, ref] = useElementIDAndRefSync('FocusedOption', idProp);
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    ref: ref,
    className: `${styles.disablePointerEvents} ${className}`,
    id: id
  }, props));
};
process.env.NODE_ENV !== "production" ? FocusedOption.propTypes = {
  /**
   * Underlying component to render
   */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Override id
   */
  id: PropTypes.string,
  /**
   * Append class
   */
  className: PropTypes.string
} : void 0;
FocusedOption.defaultProps = {
  as: 'span',
  className: ''
};
export default FocusedOption;